import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { APP_CONFIG } from '../../utils/constants';
import BrandMark from './BrandMark';

interface BrandLockupProps {
  markSize?: number | string;
  fontSize?: number | string;
  gap?: number | string;
  onDarkSurface?: boolean;
}

/** The complete symbol and wordmark, ending in a brass pen stroke. */
const BrandLockup: React.FC<BrandLockupProps> = ({ markSize = 40, fontSize = 24, gap = 1, onDarkSurface }) => {
  const theme = useTheme();
  const inverse = onDarkSurface ?? theme.palette.mode === 'dark';
  const name = APP_CONFIG.NAME;

  return (
    <Box
      component="span"
      role="img"
      aria-label={name}
      sx={{ display: 'inline-flex', alignItems: 'center', gap, whiteSpace: 'nowrap', minWidth: 0 }}
    >
      <BrandMark size={markSize} onDarkSurface={inverse} />
      <Typography
        component="span"
        sx={{
          color: inverse ? '#F5F7EF' : '#203F34',
          fontSize,
          fontWeight: 700,
          letterSpacing: '-.045em',
          lineHeight: 1,
        }}
      >
        {name.slice(0, -1)}
        <Box
          component="svg"
          viewBox="54 58 296 202"
          aria-hidden="true"
          focusable="false"
          sx={{ color: '#D8AD66', display: 'inline-block', width: '.8em', height: '.545em', ml: '.045em', verticalAlign: 'baseline' }}
        >
          <path
            d="M146 58C91 58 54 101 54 159C54 220 91 260 149 260C191 260 215 241 239 223C264 203 286 192 300 193C324 192 340 199 350 204C332 193 318 187 300 187C276 187 260 196 237 207C207 221 193 222 168 222C135 222 115 204 108 175H232V151C232 91 196 58 146 58ZM109 141C113 115 126 99 147 99C166 99 180 116 181 141Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </Box>
      </Typography>
    </Box>
  );
};

export default BrandLockup;
